import { FC } from "react";
import { Link, Image } from "capitalrx-components-2.0/lib/general";
import { GOOGLE_PLAY_STORE_APP_URL } from "@/constants/constants";

import GooglePlayLogoSvg from "@/static/images/google-play.svg?url";

interface Props {
  className?: string;
}

const GooglePlayStoreLogo: FC<Props> = ({ className }: Props): JSX.Element => {
  return (
    <Link to={GOOGLE_PLAY_STORE_APP_URL} testId="google-play-store-logo" className={className}>
      <Image className={className} src={GooglePlayLogoSvg} alt="Google Play Store" />
    </Link>
  );
};

export default GooglePlayStoreLogo;
